import Shops from "../../company/pages/shop/Shops";
import ShopDetails from "../../company/pages/shop/ShopDetails";
import CategoryIcon from "@mui/icons-material/Category";
import { ElementType } from "react";
import Dashboard from "../../company/dashboard/Dashboard";
import Subscriptions from "../../company/pages/payment/subscriptions/Subscriptions";
import SubscriptionPlans from "../../company/pages/payment/plans/SubscriptionPlans";
import QueryStatsIcon from "@mui/icons-material/QueryStats";
import Analysis from "../../company/pages/analysis/Analysis";

type Route = {
  TITLE: string;
  KEY: number;
  PATH: string;
  ELEMENT?: ElementType;
  SUBNAV?: Route[];
  SUBSUBNAV?: Route[];
  DIRECT?: boolean;
  HIDE?: boolean;
  ICON?: ElementType;
};

export const COMPANYROUTES: Route[] = [
  {
    TITLE: "Dashboard",
    KEY: 1,
    PATH: "/company/dashboard",
    ELEMENT: Dashboard,
  },
  {
    TITLE: "Shops",
    KEY: 2,
    PATH: "/company/shops",
    ICON: CategoryIcon,
    DIRECT: true,
    SUBNAV: [
      {
        TITLE: "Shops",
        KEY: 23,
        PATH: "/company/shops/list",
        ELEMENT: Shops,
      },
      {
        TITLE: "Shop Details",
        KEY: 22,
        HIDE: true,
        PATH: "/company/shops/:id",
        ELEMENT: ShopDetails,
      },
    ],
  },
  {
    TITLE: "Subscriptions",
    KEY: 1,
    PATH: "/company/subscriptions",
    ELEMENT: Subscriptions,
    ICON: CategoryIcon,
  },
  {
    TITLE: "Plans",
    KEY: 1,
    PATH: "/company/plans",
    ELEMENT: SubscriptionPlans,
    ICON: CategoryIcon,
  },
  {
    TITLE: "Analysis",
    KEY: 5,
    PATH: "/company/analysis",
    ICON: QueryStatsIcon,
    ELEMENT: Analysis,
  },
  // {
  //   TITLE: "Shop Details",
  //   KEY: 3,
  //   PATH: "/company/shops/:id",
  //   ELEMENT: ShopDetails,
  // },
  // {
  //   TITLE: "Add Shop",
  //   KEY: 4,
  //   PATH: "/company/shops/add",
  //   ELEMENT: AddShop,
  // },
];

export default COMPANYROUTES;
